import { Button, ButtonGroup, Text, useToast, VStack } from "@chakra-ui/react"
import React from "react"
import { NavLink, useNavigate } from "react-router-dom"
import { ExtendedUserFragment, useDeleteUserMutation } from "../../graphql"
import { UserTag } from "../common"

export type DeleteUserProps = {
	user: ExtendedUserFragment
}

export const DeleteUser: React.FC<DeleteUserProps> = ({ user }) => {
	const [{ fetching }, deleteUser] = useDeleteUserMutation()
	const toast = useToast()
	const navigate = useNavigate()

	const handleDelete = async () => {
		const { data, error } = await deleteUser({ userId: user._id })

		if (error) {
			toast({ description: error.message.replace("[GraphQL] ", ""), status: "error" })
			return
		}

		if (data?.deleteUser) {
			toast({ description: "Deleted the user successfully", status: "success" })
			navigate("/users")
			return
		}

		toast({ description: "Couldn't delete the user", status: "error" })
	}

	return (
		<VStack w="full" maxW={{ base: "full", xl: "2xl" }} align="stretch" spacing={4}>
			<UserTag user={user} />
			<VStack w="full" align="flex-end" spacing={4}>
				<Text fontSize="sm" color="grayscale.label" alignSelf="flex-start">
					Deleting {user.name} will hide this user from all lists but their historical records will be retained. This action cannot be undone.
				</Text>
				<ButtonGroup>
					<Button size="sm" as={NavLink} to={`/users/${user._id}`}>
						Cancel
					</Button>
					<Button size="sm" colorScheme="error" isLoading={fetching} onClick={handleDelete}>
						Delete
					</Button>
				</ButtonGroup>
			</VStack>
		</VStack>
	)
}
